<app-fullscreen-loading *ngIf="Loading()"></app-fullscreen-loading>
<div class="w-full bg-lightBG dark:bg-darkBG tracking-normal ">
    <app-header></app-header>
    <main class="min-h-main">
        <div id="main" class="main-container relative landing">
            <section class="block">
                <router-outlet></router-outlet>
            </section>
        </div>
    </main>
    <app-footer></app-footer>
</div>